import { EMPTY_LIST, EMPTY_STRING } from '../../../../../constants/common'

export function toGoogleMapPlacesPreparedItems(items) {
  return items
}

export function getGoogleMapPlacesApiData(options) {
  return [
    options.input ?? EMPTY_STRING,
    options.locationBias ?? null,
    options.locationRestriction ?? null,
    options.includedPrimaryTypes ?? null,
    options.includedRegionCodes ?? null,
    options.languageCode ?? null,
    options.regionCode ?? null,
    options.origin ?? null,
    options.inputOffset ?? null,
    options.includeQueryPredictions ?? null,
    options.sessionToken ?? null,
  ]
}

export function parseAutocompleteRpcResponse(rpc) {
  const suggestionsBlocks = rpc?.[0] ?? rpc

  function toRanges(pairs) {
    return (pairs ?? EMPTY_LIST).map(([start, len]) => ({
      length: len ?? 0,
      offset: start ?? 0, // null -> 0
    }))
  }

  return (suggestionsBlocks ?? EMPTY_LIST).map(block => {
    const s = block?.[0] ?? EMPTY_LIST

    const resourceName = s?.[0] ?? EMPTY_STRING
    const placeId = s?.[1] ?? EMPTY_STRING

    const fullTextTuple = s?.[2] ?? [EMPTY_STRING, EMPTY_LIST]
    const fullText = fullTextTuple?.[0] ?? EMPTY_STRING
    const fullTextMatches = toRanges(fullTextTuple?.[1])

    const struct = s?.[3] ?? [
      [EMPTY_STRING, EMPTY_LIST],
      [EMPTY_STRING, EMPTY_LIST],
    ]
    const mainTextTuple = struct?.[0] ?? [EMPTY_STRING, EMPTY_LIST]
    const secondaryTextTuple = struct?.[1] ?? [EMPTY_STRING, EMPTY_LIST]

    const mainText = mainTextTuple?.[0] ?? EMPTY_STRING
    const mainMatches = toRanges(mainTextTuple?.[1])
    const secondaryText = secondaryTextTuple?.[0] ?? EMPTY_STRING

    const types = s?.[4] ?? EMPTY_LIST

    return {
      kind: 'place',
      placeId,
      resourceName,
      structuredFormat: {
        mainMatches,
        mainText,
        secondaryText,
      },
      text: { matches: fullTextMatches, text: fullText },
      types,
    }
  })
}
